export default __webpack_public_path__ + "static/media/1200_Logo_Noir.1c9b9659.svg";